var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import GLTFJointComponent from "./Components/GLTFJointComponent";
import GLTFAnimationComponent from "./Components/GLTFAnimationComponent";
import GLTFModelComponent from "./Components/GLTFModelComponent";
import GrimoireInterface from "grimoirejs";
import MaterialFactory from "grimoirejs-fundamental/ref/Material/MaterialFactory";
import UniformResolverRegistry from "grimoirejs-fundamental/ref/Material/UniformResolverRegistry";
import gltfUnlit from "raw!./Shaders/gltf-unlit.sort";
export default () => {
    GrimoireInterface.register(() => __awaiter(this, void 0, void 0, function* () {
        GrimoireInterface.registerComponent("GLTFModel", GLTFModelComponent);
        GrimoireInterface.registerComponent("GLTFAnimation", GLTFAnimationComponent);
        GrimoireInterface.registerComponent("GLTFJoint", GLTFJointComponent);
        GrimoireInterface.registerNode("model", ["GLTFModel"], {}, "object");
        GrimoireInterface.registerNode("gltf-mesh", [], {
            material: "new(gltf-unlit)"
        }, "mesh");
        GrimoireInterface.registerNode("gltf-joint", ["GLTFJoint"], {}, "object");
        GrimoireInterface.registerNode("gltf-assets", [], {});
        GrimoireInterface.registerNode("gltf-animation", ["GLTFAnimation"], {});
        MaterialFactory.addSORTMaterial("gltf-unlit", gltfUnlit);
        UniformResolverRegistry.add("JOINTMATRIX", (valInfo, material) => {
            material.addArgument("boneMatrices", {
                converter: "Object",
                default: null
            });
            return (proxy, info) => {
                if (!material.arguments["boneMatrices"]) {
                    return;
                }
                proxy.uniformMatrixArray(valInfo.name, material.arguments["boneMatrices"]);
            };
        });
    }));
};



// WEBPACK FOOTER //
// ./src/main.ts